import { memo } from "react";
import { styled } from "@mui/material";
import { DragDropContext, Droppable, OnDragEndResponder } from "react-beautiful-dnd";
import UploadMultipleItem from "./UploadMultipleItem";
import { IFile } from "components/upload/UploadSteps/UploadSteps";

interface IProps {
  files: IFile[];
  removeFileFromArray: (index: number) => void;
  onDragEnd: OnDragEndResponder;
}

const UploadMultiple = memo((props: IProps) => {
  const { files, removeFileFromArray, onDragEnd } = props;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-file-list">
        {provided => (
          <Container ref={provided.innerRef} {...provided.droppableProps}>
            {files.map((el: IFile, index: number) => (
              <UploadMultipleItem
                key={el.id}
                dataUrl={el.url}
                id={el.id}
                fileName={el.file ? el.file.name : ""}
                index={index}
                removeFileFromArray={removeFileFromArray}
                progressPercent={el.uploadProgress}
              />
            ))}
            {provided.placeholder}
          </Container>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default UploadMultiple;

const Container = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
  gap: "16px 24px",
  marginTop: "35px"
});
